import { useState } from "react";

export default function FooterMenu() {
  const [clickBottomMenu, setClickBottomMenu] = useState<boolean>(false);

  function toggleClick(): void {
    clickBottomMenu ? setClickBottomMenu(false) : setClickBottomMenu(true);
  }

  return (
    <>
      <section
        id="bottom"
        className={
          clickBottomMenu
            ? "d-none d-sm-block open"
            : "d-none d-sm-block closed"
        }
        onClick={toggleClick}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <h4>Conecte</h4>
              <p>Comunidade</p>
            </div>
            <div className="col-md-3">
              <h4>Telefones</h4>
              <p>Entre em contato</p>
            </div>
            <div className="col-md-3">
              <h4>Siga-nos</h4>
              <p>Fique por dentro</p>
            </div>
            <div className="col-md-3">
              <h4>Intranet</h4>
              <p>Acesse</p>
            </div>
          </div>
        </div>
      </section>
      <section
        id="bottom-detail"
        className={
          clickBottomMenu
            ? "d-none d-sm-block open"
            : "bottom-detail d-none d-sm-block closed"
        }
      >
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <ul>
                <li className="item-2290">
                  <a href="https://email.unicamp.br" target="_blank" rel="noopener noreferrer">
                    WEBMAIL
                  </a>
                </li>
                <li className="item-2291">
                  <a href="https://moodle.ggte.unicamp.br" target="_blank"rel="noopener noreferrer">
                    ENSINO ABERTO
                  </a>
                </li>
                <li className="item-2484">
                  <a href="https://sigad.unicamp.br" target="_blank" rel="noopener noreferrer">
                    SIGAD
                  </a>
                </li>
                <li className="item-869">
                  <a href="https://www.feagri.unicamp.br/portal/estrutura-organizacional/secoes/secao-de-informatica">
                    INFORMÁTICA
                  </a>
                </li>
                <li className="item-2591">
                  <a href="https://www.feagri.unicamp.br/portal/estrutura-organizacional/secoes/secao-administrativa/secao-administrativa-rh">
                    RH/CONCURSOS
                  </a>
                </li>
                <li className="item-3627">
                  <a href="https://www.feagri.unicamp.br/portal/estrutura-organizacional/secoes/infraestrutura">
                    INFRAESTRUTURA
                  </a>
                </li>{" "}
              </ul>
            </div>
            <div className="col-md-3">
              <ul className="menu">
                <li className="item-2593">
                  <a href="https://www.feagri.unicamp.br/extranet/contato/buscar-contatos">BUSCAR CONTATOS</a>
                </li>
                <li className="item-2306">
                  <a href="https://www.feagri.unicamp.br/extranet/contato/diretoria">DIRETORIA</a>
                </li>
                <li className="item-2307">
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.07.00.00.00">GRADUAÇÃO</a>
                </li>
                <li className="item-2308">
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.08.00.00.00">
                    PÓS-GRADUAÇÃO
                  </a>
                </li>
                <li className="item-2309">
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.29.00.00.00">PESQUISA</a>
                </li>
                <li className="item-2310">
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.21.00.00.00">EXTENSÃO</a>
                </li>
                <li className="item-2305">
                  <a href="https://www.feagri.unicamp.br/portal/como-chegar-feagri">COMO CHEGAR?</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <ul>
                <li>
                  <a href="https://www.facebook.com/feagri" target="_blank">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-facebook.png"
                      alt="Facebook"
                    />
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/feagri" target="_blank">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-twitter.png"
                      alt="Twitter"
                    />
                    Twitter
                  </a>
                </li>
                <li>
                  <a href="http://www.youtube.com/feagritvunicamp" target="_blank">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-youtube.png"
                      alt="Youtube"
                    />
                    Youtube
                  </a>
                </li>
                {/* <li>
                  <a href="#">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-pinterest.png"
                      alt="Pinterest"
                    />
                    Pinterest
                  </a>
                </li> */}
                <li>
                  <a href="https://www.instagram.com/unicamp.feagri/" target="_blank">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-20x20px-instagram.png"
                      alt="Instagram"
                    />
                    Instagram
                  </a>
                </li>                
                <li>
                  <a href="https://linktr.ee/feagri" target="_blank">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-linktree.png"
                      alt="LinkTree"
                    />
                    Linktree
                  </a>
                </li>

              </ul>
            </div>
            <div className="col-md-3">
              <ul>
                <li>
                  <a
                    href="https://www.feagri.unicamp.br/intranet/#/feagri/calendar"
                    target="_blank"
                  >
                    Agendas
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.feagri.unicamp.br/intranet/"
                    target="_blank"
                  >
                    Intranet/Sistemas
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.feagri.unicamp.br/intranet/#/esqueceu-a-senha"
                    target="_blank"
                  >
                    Esqueceu sua senha?
                  </a>
                </li>
                <li>
                  <a
                    href="https://forms.office.com/r/9juSeT9eXd?embed=true"
                    target="_blank"
                  >
                    Ocorrências Limpeza
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.feagri.unicamp.br/app/veiculo-checklist"
                    target="_blank"
                  >
                    App CheckList Veículo
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.feagri.unicamp.br/extranet/mural/"
                    target="_blank"
                  >
                    Horário de Hoje Salas de Aula
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.feagri.unicamp.br/extranet/academico/disciplinas/grade-horario"
                    target="_blank"
                  >
                    Consulta Grade Horário Semestral
                  </a>
                </li>                
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="mobile-bottom" className="d-block d-sm-none">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="block">
                <h3 className="bottom-menu-title">CONECTE</h3>
                <ul className="nav menu">
                    <li>
                    <a href="https://email.unicamp.br" target="_blank" rel="noopener noreferrer">
                        WEBMAIL
                    </a>
                    </li>
                    <li>
                    <a href="https://moodle.ggte.unicamp.br" target="_blank"rel="noopener noreferrer">
                        ENSINO ABERTO
                    </a>
                    </li>
                    <li>
                    <a href="https://sigad.unicamp.br" target="_blank" rel="noopener noreferrer">
                        SIGAD
                    </a>
                    </li>
                    <li> 
                    <a href="https://www.feagri.unicamp.br/portal/estrutura-organizacional/secoes/secao-de-informatica"
                     target="_blank" rel="noopener noreferrer">
                        INFORMÁTICA
                    </a>
                    </li>
                    <li>
                    <a href="https://www.feagri.unicamp.br/portal/estrutura-organizacional/secoes/secao-administrativa/secao-administrativa-rh"
                     target="_blank" rel="noopener noreferrer">
                        RH/CONCURSOS
                    </a>
                    </li>
                    <li>
                    <a href="https://www.feagri.unicamp.br/portal/estrutura-organizacional/secoes/infraestrutura"
                     target="_blank" rel="noopener noreferrer">
                        INFRAESTRUTURA
                    </a>
                    </li>
                </ul>
              </div>
              <div className="block">
                <h3 className="bottom-menu-title">TELEFONES</h3>
                <ul className="nav menu">
                <li>
                  <a href="https://www.feagri.unicamp.br/extranet/contato/buscar-contatos">BUSCAR CONTATOS</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/extranet/contato/diretoria">DIRETORIA</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.07.00.00.00">GRADUAÇÃO</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.08.00.00.00">
                    PÓS-GRADUAÇÃO
                  </a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.29.00.00.00">PESQUISA</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/extranet/contato/28.21.00.00.00">EXTENSÃO</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/portal/como-chegar-feagri">COMO CHEGAR?</a>
                </li>
                </ul>
              </div>
              <div className="block">
                <h3 className="bottom-menu-title">SIGA-NOS</h3>
                <ul className="nav menu">
                  <li>
                    <a href="https://www.facebook.com/feagri" target="_blank">
                      <img
                        src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-facebook.png"
                        alt="Facebook"
                      />
                      <span className="image-title">Facebook</span>{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/feagri">
                      <img
                        src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-twitter.png"
                        alt="Twitter"
                      />
                      <span className="image-title">Twitter</span>{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      className="youtube"
                      href="http://www.youtube.com/feagritvunicamp"
                      target="_blank"
                    >
                      <img
                        src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-34x34px-youtube.png"
                        alt="Youtube "
                      />
                      <span className="image-title">Youtube </span>{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/unicamp.feagri/"
                      target="_blank"
                    >
                      <img
                        src="https://www.feagri.unicamp.br/portal/images/icones/icones-circular-20x20px-instagram.png"
                        alt="Instragram"
                      />
                      <span className="image-title">Instragram</span>{" "}
                    </a>
                  </li>
                  <li>
                  <a href="https://linktr.ee/feagri" target="_blank">
                    <img
                      src="https://www.feagri.unicamp.br/portal/images/icones/icones-linktree.png"
                      alt="LinkTree"
                    />
                    <span className="image-title">Linktree</span>{" "}
                  </a>
                  </li>
                </ul>
              </div>
              <div className="block">
                <h3 className="bottom-menu-title">Intranet</h3>
                <ul className="nav menu">
                  <li>
                    <a
                      href="https://www.feagri.unicamp.br/calendario/week.php"
                      target="_blank"
                    >
                      Agendas
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.feagri.unicamp.br/intranet/"
                      target="_blank"
                    >
                      Intranet/Sistemas
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.feagri.unicamp.br/intranet/esqueciminhasenha.php"
                      target="_blank"
                    >
                      Esqueceu sua senha?
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://forms.office.com/r/9juSeT9eXd?embed=true"
                      target="_blank"
                    >
                      Ocorrências Limpeza
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.feagri.unicamp.br/app/veiculo-checklist"
                      target="_blank"
                    >
                      App CheckList Veículo
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.feagri.unicamp.br/extranet/mural/"
                      target="_blank"
                    >
                      Horário de Hoje Salas de Aula
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.feagri.unicamp.br/extranet/academico/disciplinas/grade-horario"
                      target="_blank"
                    >
                      Consulta Grade Horário Semestral
                    </a>
                  </li>                
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
